const E = {
  NoOrders: 'There are currently no orders available.',
  NewOrder1: "If you'd like to create a new order, please click",
  NewOrder2: 'New Order.',
  NoResults: 'We couldn’t find any orders that match your search criteria.',
  NoResultsBody: 'Please double check your search criteria or try a broader search. If you need assistance, please contact your Bureau Veritas representative.',
  NewOrder: 'New Order',
  'Pinned Orders': 'Pinned Orders',
  'My Orders': 'My Orders',
  'All Orders': 'All Orders',
  'Order #': 'Order #',
  Placed: 'Placed',
  Shipped: 'Shipped',
  'Project #': 'Project #',
  CreatedBy: 'Created By',
  CreatedOn: 'Created On',
  WayBill: 'WayBill',
  'eCOC Template': 'eCOC Template',
  cancel: 'cancel',
  SiteLocation: 'Site Location',
  JobAttention: 'Job Attention',
  Received: 'Received',
  Status: 'Status',
};

const F = {
  NoOrders: 'Aucune commande disponible pour le moment.',
  NewOrder1: 'Pour créer une nouvelle commander, cliquer sur',
  NewOrder2: 'Nouvelle commande.',
  NoResults: 'Aucune commande ne correspond à vos critères de recherche.',
  NoResultsBody: 'Veuillez vérifier les critères de recherche ou les élargir. Si vous avez besoin d’aide, veuillez contacter votre représentant des Lab BV.',
  NewOrder: 'Nouvelle commande',
  'Pinned Orders': 'Commandes épinglées',
  'My Orders': 'Mes commandes',
  'All Orders': 'Toutes les commandes',
  'Order #': 'No de commande',
  Placed: 'Passées',
  Shipped: 'Expédiées',
  'Project #': 'No de projet',
  CreatedBy: 'Créé par',
  CreatedOn: 'Créé le',
  WayBill: 'Bordereau d’expédition',
  'eCOC Template': 'Modèle d’eCDR',
  cancel: 'Annuler',
  SiteLocation: 'Emplacement du site',
  JobAttention: 'Dossier à l’attention de',
  Received: 'Reçu',
  Status: 'Statut',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/orders.js